<template>
  <div class="dashboard content__area">
    <div class="container-fluid">
      <div class="content__wrapper">
        <div class="row">
          <!-- SESSION , EARNING , OCCUPANCY REPORT SECTION -->
          <div class="col-lg-4">
            <div class="dashboard__map__section">
              <!-- GOOGLE MAP FOR PROPERTY LIST SECTION -->
              <div
                class="content__box dashboard__map"
                @click="mapHeightmethod()"
                :style="{ height: mapHeight + 'px' }"
              >
                <GMap @search_proprty_list="getPropertyList($event)" />
              </div>
              <!-- PROPERTY LISTS -->
              <div
                class="content__box poperty__lists__map mt-2"
                :class="{ 'cursor-pointer': activeToSeeProperty === false }"
                @click.stop="showPropertyLists()"
                :style="{ height: propertyListsheight + 'px' }"
                v-if="property_list.length > 0"
              >
                <div
                  class="card poperty__lists__map__info card-widget widget-user cursor-pointer"
                  v-for="(p, index) in property_list"
                  :key="index"
                  @click="redirectPropertyDetails(p.space_id)"
                >
                  <div
                    class="widget-user-header widget-user-header_spc_lst text-white"
                    :style="{ 'background-image': 'url(' + p.image + ')' }"
                  >
                    <div class="gmap__progress">
                      <div style="z-index: 10">
                        <div class="progress-circle__container">
                          <span class="progress-circle__percent"
                            >{{ p.occupancy_percentage.toFixed(2) }}%</span
                          >
                          <svg
                            viewBox="0 0 106 106"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            class="progress-circle"
                          >
                            <g
                              id="Page-1"
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <g
                                id="ProgressBar"
                                transform="translate(-17.000000, -17.000000)"
                              >
                                <circle
                                  id="Oval"
                                  stroke="#949494"
                                  stroke-width="5"
                                  fill-rule="nonzero"
                                  cx="70"
                                  cy="70"
                                  r="50"
                                />
                                <path
                                  d="M70,120 C97.6142375,120 120,97.6142375 120,70 C120,42.3857625 97.6142375,20 70,20 C42.3857625,20 20,42.3857625 20,70 C20,97.6142375 42.3857625,120 70,120 Z"
                                  id="Oval-Copy"
                                  stroke="#f5a623"
                                  stroke-width="5"
                                  :stroke-dasharray="
                                    circle(p.occupancy_percentage.toFixed(2))
                                  "
                                  fill-rule="nonzero"
                                  transform="translate(70.000000, 70.000000) rotate(-125.000000) translate(-70.000000, -70.000000) "
                                  class="progress-circle__path"
                                />
                              </g>
                            </g>
                          </svg>
                        </div>
                        <p class="mt-1 txt--xs txt--semi-bold text-white">
                          Occupied
                        </p>
                      </div>
                      <div class="gmap__space">
                        <p class="gmapInfo__space__name txt--ss txt--semi-bold">
                          {{
                            p.property_name != ""
                              ? p.property_name
                              : p.address.split(",")[0]
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8 mt-4 mt-lg-0">
            <div class="row">
              <!-- AVG REPORT SECTION -->
              <div :class="['col-12 mb-4']">
                <div :class="['content__box',!report_access ? 'restricted' : '']">
                  <div class="content__box__body">
                    <div class="row">
                      <!-- TRANSIENT CUSTOMER COUNT -->
                      <div
                        class="col-sm-6 col-md-4 col-xl mb-3 mb-md-0 customers-records"
                      >
                      <div class="d-flex justify-content-between">
                        <p class="txt--ss opacity--50">{{ $t("TC") }}</p>
                        <p class="txt--ss txt--primary cursor-pointer"><i class="far fa-question-circle" v-tooltip="helperTexts.transient_customer_count"></i></p>
                      </div>
                        
                        <div v-if="transient_loader == 0">
                          <p class="txt--fslg pt-2">
                            {{ session_reports.transient_customer }}
                          </p>
                          <p
                            :class="[
                              'transient-customers-records txt--ss mt-3',
                              session_reports.transient_customer_inc
                                ? 'txt--green'
                                : 'txt--red',
                            ]"
                          >
                            <span
                              :class="[
                                session_reports.transient_customer_inc
                                  ? 'txt--green'
                                  : 'txt--red',
                                'rounded-circle',
                              ]"
                            ></span>
                            {{ session_reports.transient_customer_inc_value }}%
                          </p>
                        </div>
                        <div v-else-if="transient_loader == 2">
                          <p class="txt--ss txt--red mt-2">Something went wrong!</p>
                          <button 
                            @click="getTransientReport" 
                            type="button" 
                            class="button button--primary button--sm mr-3 mt-2"
                          >
                            <span>Reload</span>
                          </button>
                        </div>
                        <div v-else>
                          <div class="d-flex justify-content-center">
                            <div class="lds-ring">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- PERMIT CUSTOMER COUNT -->
                      <div
                        class="col-sm-6 col-md-4 col-xl mt-3 mt-md-0 customers-records"
                      >
                        <div class="d-flex justify-content-between">
                          <p class="txt--ss opacity--50">{{ $t("MC") }}</p>
                          <p class="txt--ss txt--primary cursor-pointer"><i class="far fa-question-circle" v-tooltip="helperTexts.permit_customer_count"></i></p>
                        </div>
                        
                        <div v-if="permit_customer_loader == 0">
                          <p class="txt--fslg pt-2">
                            {{ session_reports.monthly_customer }}
                          </p>
                          <p
                            :class="[
                              'transient-customers-records txt--ss mt-3',
                              session_reports.monthly_customer_inc
                                ? 'txt--green'
                                : 'txt--red',
                            ]"
                          >
                            <span
                              :class="[
                                session_reports.monthly_customer_inc
                                  ? 'txt--green'
                                  : 'txt--red',
                                'rounded-circle',
                              ]"
                            ></span>
                            {{ session_reports.monthly_customer_inc_value }}%
                          </p>
                        </div>
                        <div v-else-if="permit_customer_loader == 2">
                          <p class="txt--ss txt--red mt-2">Something went wrong!</p>
                          <button 
                            @click="getPermitCustomer" 
                            type="button" 
                            class="button button--primary button--sm mr-3 mt-2"
                          >
                            <span>Reload</span>
                          </button>
                        </div>
                        <div v-else>
                          <div class="d-flex justify-content-center">
                            <div class="lds-ring">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- ANONYMOUS CUSTOMER COUNT -->
                      <div
                        class="col-sm-6 col-md-4 col-xl mt-3 mt-xl-0 customers-records"
                      >
                        <div class="d-flex justify-content-between">
                          <p class="txt--ss opacity--50">{{ $t("AC") }}</p>
                          <p class="txt--ss txt--primary cursor-pointer"><i class="far fa-question-circle" v-tooltip="helperTexts.anonymous_customer_count"></i></p>
                        </div>
                        
                        <div v-if="anonymous_customer_loader == 0">
                          <p class="txt--fslg pt-2">
                            {{ session_reports.anonymous_customer }}
                          </p>
                          <p
                            :class="[
                              'transient-customers-records txt--ss mt-3',
                              session_reports.anonymous_customer_inc
                                ? 'txt--green'
                                : 'txt--red',
                            ]"
                          >
                            <span
                              :class="[
                                session_reports.anonymous_customer_inc
                                  ? 'txt--green'
                                  : 'txt--red',
                                'rounded-circle',
                              ]"
                            ></span>
                            {{ session_reports.anonymous_customer_inc_value }}%
                          </p>
                        </div>                        
                        <div v-else-if="anonymous_customer_loader == 2">
                          <p class="txt--ss txt--red mt-2">Something went wrong!</p>
                          <button 
                            @click="getAnonymousCustomer" 
                            type="button" 
                            class="button button--primary button--sm mr-3 mt-2"
                          >
                            <span>Reload</span>
                          </button>
                        </div>
                        <div v-else>
                          <div class="d-flex justify-content-center">
                            <div class="lds-ring">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- AVG SESSION DURATION -->
                      <!--{{--<div
                        class="col-sm-6 col-md-4 col-xl mt-3 mt-md-0 customers-records"
                      >
                        <div class="d-flex justify-content-between">
                          <p class="txt--ss opacity--50">{{ $t("AVGSD") }}</p>
                          <p class="txt--ss txt--primary cursor-pointer"><i class="far fa-question-circle" v-tooltip="helperTexts.avg_session_duration"></i></p>
                        </div>
                        
                        <div v-if="avg_session_loader == 0">
                          <p class="txt--fslg pt-2">
                            {{ session_reports.avg_session_duration }}
                          </p>
                          <p
                            :class="[
                              'transient-customers-records txt--ss mt-3',
                              session_reports.avg_session_duration_inc
                                ? 'txt--green'
                                : 'txt--red',
                            ]"
                          >
                            <span
                              :class="[
                                session_reports.avg_session_duration_inc
                                  ? 'txt--green'
                                  : 'txt--red',
                                'rounded-circle',
                              ]"
                            ></span>
                            {{
                              session_reports.avg_session_duration_inc_value
                            }}%
                          </p>
                        </div>
                        <div v-else-if="avg_session_loader == 2">
                          <p class="txt--ss txt--red mt-2">Something went wrong!</p>
                          <button 
                            @click="getAvgSessionReport" 
                            type="button" 
                            class="button button--primary button--sm mr-3 mt-2"
                          >
                            <span>Reload</span>
                          </button>
                        </div>
                        <div v-else>
                          <div class="d-flex justify-content-center">
                            <div class="lds-ring">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                          </div>
                        </div>
                      </div>--}}-->
                      <!-- AVG SESSION PRICE -->
                      <!--{{--<div
                        class="col-sm-6 col-md-4 col-xl mt-3 mt-xl-0 customers-records"
                      >
                        <div class="d-flex justify-content-between">
                          <p class="txt--ss opacity--50">{{ $t("AVGSP") }}</p>
                          <p class="txt--ss txt--primary cursor-pointer"><i class="far fa-question-circle" v-tooltip="helperTexts.avg_session_price"></i></p>
                        </div>
                        
                        <div v-if="avg_session_price_loader == 0">
                          <p class="txt--fslg pt-2">
                            ${{ session_reports.avg_session_price }}
                          </p>
                          <p
                            :class="[
                              'transient-customers-records txt--ss mt-3',
                              session_reports.avg_session_price_inc
                                ? 'txt--green'
                                : 'txt--red',
                            ]"
                          >
                            <span
                              :class="[
                                session_reports.avg_session_price_inc
                                  ? 'txt--green'
                                  : 'txt--red',
                                'rounded-circle',
                              ]"
                            ></span>
                            {{ session_reports.avg_session_price_inc_value }}%
                          </p>
                        </div>
                        <div v-else-if="avg_session_price_loader == 2">
                          <p class="txt--ss txt--red mt-2">Something went wrong!</p>
                          <button 
                            @click="getAvgSessionPrice" 
                            type="button" 
                            class="button button--primary button--sm mr-3 mt-2"
                          >
                            <span>Reload</span>
                          </button>
                        </div>
                        <div v-else>
                          <div class="d-flex justify-content-center">
                            <div class="lds-ring">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                          </div>
                        </div>
                      </div>--}}-->
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <!-- ACTIVITY SECTION -->
                <div class="content__box content__box--activity">
                  <div class="content__box__header pb-0">
                    <div class="top__filter">
                      <ul class="top__filter__ul">
                        <li class="cursor-default">{{ $t("ACTIVITY") }}</li>
                      </ul>
                      <ul class="top__filter__ul d-none">
                        <li
                          :class="[activity_filter == 1 ? 'active' : '']"
                          @click="changeFilter(10)"
                        >
                          All
                        </li>
                        <li
                          :class="[activity_filter == 2 ? 'active' : '']"
                          @click="changeFilter(11)"
                        >
                          Positive
                        </li>
                        <li
                          :class="[activity_filter == 3 ? 'active' : '']"
                          @click="changeFilter(12)"
                        >
                          Moderate
                        </li>
                        <li
                          :class="[activity_filter == 4 ? 'active' : '']"
                          @click="changeFilter(13)"
                        >
                          Negative
                        </li>
                      </ul>
                    </div>
                    <div class="monthActivity">
                      <div class="form-row">
                        <div class="col-auto mb-2">
                          <v-select
                            class="style-chooser monthly-filter-select selectTransparent"
                            label="name"
                            :searchable="false"
                            :options="month_list"
                            :clearable="false"
                            v-model="currentMonthDate"
                             transition="none"
                            :reduce="(name) => name.value"
                            @input="changeActivityMonth()"
                            placeholder="Select month"
                          ></v-select>
                        </div>
                        <div class="col-auto mb-2">
                          <v-select
                            class="style-chooser monthly-filter-select selectTransparent"
                            label="name"
                            :searchable="false"
                            v-model="currentYear"
                            transition="none"
                            :options="years"
                            :clearable="false"
                            :reduce="(name) => name.value"
                            @input="changeActivityYear()"
                            placeholder="Select year"
                          >
                          </v-select>
                        </div>
                      </div>

                      <VueSlickCarousel v-bind="carouselSettings">
                        <div v-for="(m, i) in currentMonth" :key="i">
                          <div
                            class="monthDate"
                            :class="{
                              active:
                                (m.full_date === currentDate &&
                                  activedate === null) ||
                                activedate === i,
                              opacity6: m.full_date > currentDate,
                            }"
                            @click="focusDate(i, $event)"
                          >
                            <p class="monthDay mb-1">{{ m.day }}</p>
                            <p class="monthNum mb-1">{{ m.date }}</p>
                            <div class="activeDay"></div>
                          </div>
                        </div>
                        <template #prevArrow="prevArrowOption">
                          <button
                            type="button"
                            data-role="none"
                            class="custom-arrow custom-arrow-left"
                            :class="{
                              disabledMonth: prevArrowOption.currentSlide == 0,
                            }"
                          >
                            <i class="fas fa-angle-left"></i>
                          </button>
                        </template>
                        <template #nextArrow="nextArrowOption">
                          <button
                            type="button"
                            class="custom-arrow custom-arrow-right"
                            :class="{
                              disabledMonth:
                                nextArrowOption.currentSlide == today - 1,
                            }"
                          >
                            <i class="fas fa-angle-right"></i>
                          </button>
                        </template>
                      </VueSlickCarousel>
                    </div>
                  </div>
                  <div class="content__divider"></div>

                  <div
                    class="content__box__body box__height box__height--activity"
                  >
                    <div
                      v-for="(activity, index) in activity_list"
                      :key="index"
                    >
                      <div class="activity__new-time">
                        <p class="txt--ss opacity--50 text-truncate">
                          {{ activity.created_at_time }}
                        </p>
                        <span class="activity__line"></span>
                      </div>

                      <div class="activity__new has-activity">
                        <div
                          class="activity__indicator activity__indicator--dasboard"
                        >
                          <div class="activity__blue"></div>
                        </div>
                        <div class="activity__txt">
                          <div class="activity__image">
                            <img
                              src="@/assets/images/car.png"
                              class="w-100"
                              alt
                            />
                          </div>
                          <div
                            :class="[
                              'activity__msg txt--semi-bold',
                              activity.target == 'bookings'
                                ? 'cursor-pointer'
                                : '',
                            ]"
                            @click="openModal(activity)"
                          >
                            <p class="txt--ss">{{ activity.message }}</p>
                          </div>
                        </div>
                        <div class="activity__address mt-2 mt-sm-0">
                          <p class="txt--xs opacity--50 text-truncate">
                            {{
                              activity.property_name != ""
                                ? activity.property_name
                                : activity.address_short
                            }}
                          </p>
                          <p class="txt--xs opacity--50 text-truncate pt-2" v-if="activity.booking_type == 'Monthly Customer'">
                            Permit Customer
                          </p>
                          <p class="txt--xs opacity--50 text-truncate pt-2" v-else>
                            {{activity.booking_type != "" ? activity.booking_type : ""}}
                          </p>
                        </div>
                      </div>
                    </div>

                    <infinite-loading
                      @infinite="getActivities"
                      :distance="10"
                      :identifier="activity_infiniteId"
                    >
                      <div slot="spinner">
                        <div class="d-flex justify-content-center mt-4">
                          <div class="lds-ring">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                        </div>
                      </div>
                      <div slot="no-more"></div>
                      <div slot="no-results">No data found</div>
                    </infinite-loading>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 mt-4 mt-lg-0">
                <div class="graph__area">
                  <!-- OCCUPANCY REPORT -->
                  <div :class="['content__box content__box--graph h-50',!report_access ? 'restricted' : '']">
                    <div class="content__box__header">
                      <div class="top__filter">
                        <ul class="top__filter__ul">
                          <li class="active cursor-default">
                            {{ $t("OCCUP") }}
                          </li>
                        </ul>
                        <ul class="top__filter__ul">
                          <li :class="[occupancy_customer_type == 1 ? 'active' : '']"
                            @click="getOccupancyChartData(1)">
                            ALL                        
                          </li>
                          <li :class="[occupancy_customer_type == 2 ? 'active' : '']"
                            @click="getOccupancyChartData(2)">
                          Transient            
                          </li>
                          <li :class="[occupancy_customer_type == 3 ? 'active' : '', 'dropdown-container-activate']">
                            <span @click="getOccupancyChartData(3)">Permit</span>
                            <div class="dropdown-container">
                              <p
                                @click="getOccupancyChartData(3)"
                                :class="[occupancy_customer_type == 3 && permit_type_filter === 1 ? 'active' : '']"
                              >ALL</p>
                              <p
                                @click="getOccupancyChartData(3, 2)"
                                :class="[permit_type_filter === 2 ? 'active' : '']"
                              >Flex</p>
                              <p
                                @click="getOccupancyChartData(3, 3)"
                                :class="[permit_type_filter === 3 ? 'active' : '']"
                              >Recurring</p>
                            </div>                     
                          </li>
                          <li :class="[occupancy_customer_type == 4 ? 'active' : '']"
                            @click="getOccupancyChartData(4)">
                            Anonymous                        
                          </li>

                          <li class="active"><i class="far fa-question-circle" v-tooltip="helperTexts.occupancy_chart"></i></li>
                        </ul>
                      </div>
                      <div v-if="occupancy_loader == 0">
                        <h2 class="primaryHeader">{{ occupancy_total }}%</h2>
                        <p
                          :class="[
                            'transient-customers-records txt--ss mt-3',
                            occupancy_inc ? 'txt--green' : 'txt--red',
                          ]"
                        >
                          <span
                            :class="[
                              occupancy_inc ? 'txt--green' : 'txt--red',
                              'rounded-circle',
                            ]"
                          ></span>
                          {{ occupancy_inc_percentage }}%
                        </p>
                      </div>
                      <div v-else-if="occupancy_loader == 2">
                        <p class="txt--ss txt--red mt-2 align-middle">Something went wrong!</p>
                        <button  @click="getOccupancyChartData(occupancy_customer_type)" type="button" class="button button--primary button--sm mr-3 mt-2">
                          Reload
                        </button>
                      </div>
                    </div>
                    <div
                      class="content__box__body responsive__height pt-0"
                      v-if="occupancy_loader == 0"
                    >
                      <Occupancy :data="occupancy_chart" />
                    </div>
                    <!-- <div v-else-if="occupancy_reloader">
                        <p class="txt--ss txt--red mt-2 align-middle">Something went wrong!</p>
                        <button @click="getOccupancyChartData" type="button" class="button button--primary button--sm mr-3 mt-2">Reload</button>
                    </div> -->
                    <div
                      class="content__box__body responsive__height pt-0"
                      v-else-if="occupancy_loader == 1"
                    >
                      <div class="d-flex justify-content-center">
                        <div class="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- SESSION , EARNING REPORT -->
                  <div :class="['content__box content__box--graph mt-4 h-50',!report_access ? 'restricted' : '']">
                    <div class="content__box__header">
                      <div class="top__filter">
                        <ul class="top__filter__ul">
                          <li
                            :class="[earning == 1 ? 'active' : '']"
                            @click="changeFilter(5)"
                          >
                            {{ $t("SESSION") }}
                          </li>
                          <li
                            :class="[earning == 2 ? 'active' : '']"
                            @click="changeFilter(6)"
                          >
                            {{ $t("EARN") }}
                          </li>
                        </ul>

                        <ul class="top__filter__ul">
                          <li :class="[earning_customer_type == 1 ? 'active' : '']"
                            @click="getSessionAndEarnings(earning,1)">
                            ALL                        
                          </li>
                          <li :class="[earning_customer_type == 2 ? 'active' : '']"
                            @click="getSessionAndEarnings(earning,2)">
                          Transient            
                          </li>
                          <li :class="[earning_customer_type == 3 ? 'active' : '', 'dropdown-container-activate']">
                            <span @click="getSessionAndEarnings(earning, 3)">Permit</span>
                            <div class="dropdown-container" v-if="earning === 1">
                              <p
                                @click="getSessionAndEarnings(earning, 3)"
                                :class="[earning_customer_type == 3 && earning_permit_type_filter === 1 ? 'active' : '']"
                              >ALL</p>
                              <p
                                @click="getSessionAndEarnings(earning, 3, 2)"
                                :class="[earning_permit_type_filter === 2 ? 'active' : '']"
                              >Flex</p>
                              <p
                                @click="getSessionAndEarnings(earning, 3, 3)"
                                :class="[earning_permit_type_filter === 3 ? 'active' : '']"
                              >Recurring</p>
                            </div>                     
                          </li>
                          <li :class="[earning_customer_type == 4 ? 'active' : '']"
                            @click="getSessionAndEarnings(earning,4)">
                            Anonymous                        
                          </li>

                          <li class="active"><i class="far fa-question-circle" v-tooltip="earning==1 ? helperTexts.session_chart : helperTexts.earning_chart"></i></li>
                        </ul>
                      </div>
                      <div v-if="session_earning_loader == 0">
                        <h2 class="primaryHeader">
                          {{
                            earning == 2
                              ? "$" + session_earning_chart_total
                              : session_earning_chart_total
                          }}
                        </h2>
                        <p
                          :class="[
                            'transient-customers-records txt--ss mt-3',
                            session_earning_chart_inc
                              ? 'txt--green'
                              : 'txt--red',
                          ]"
                        >
                          <span
                            :class="[
                              session_earning_chart_inc
                                ? 'txt--green'
                                : 'txt--red',
                              'rounded-circle',
                            ]"
                          ></span>
                          {{ session_earning_chart_percentage }}%
                        </p>
                      </div>
                      <div v-else-if="session_earning_loader == 2">
                        <p class="txt--ss txt--red mt-2 align-middle">Something went wrong!</p>
                        <button @click="getSessionAndEarnings(earning, earning_customer_type)" type="button" class="button button--primary button--sm mr-3 mt-2">Reload</button>
                      </div>
                    </div>
                    <div
                      class="content__box__body responsive__height pt-0"
                      v-if="session_earning_loader == 0"
                    >
                      <SessionChart v-if="earning==1" :data="session_chart"/>
                      <Chart :data="session_chart" :chart_type="earning" v-else/>
                    </div>
                    <!-- <div v-else-if="session_earning_reloader">
                        <p class="txt--ss txt--red mt-2 align-middle">Something went wrong!</p>
                        <button @click="getEarningChartData" type="button" class="button button--primary button--sm mr-3 mt-2">Reload</button>
                    </div> -->
                    <div
                      class="content__box__body responsive__height pt-0"
                      v-else-if="session_earning_loader == 1"
                    >
                      <div class="d-flex justify-content-center">
                        <div class="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL -->
    <SessionDetails @session_removed="refreshActivity" />
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import GMap from "@/components/Maps";
import Chart from "@/components/ChartDrill";
import Occupancy from "@/components/ChartOccupancy";
import commonservices from "../../services/CommonService";
import "vue-select/dist/vue-select.css";
import SessionDetails from "@/components/modals/sessionDetails";
import helperTexts from "@/assets/data/helperText.js";

import SessionChart from "@/components/sessionChart";

const service = new commonservices();

export default {
  name: "Dashboard",
  components: {
    SessionChart,
    VueSlickCarousel: VueSlickCarousel,
    GMap: GMap,
    Chart: Chart,
    Occupancy: Occupancy,
    SessionDetails: SessionDetails,
  },
  data() {
    return {
      helperTexts: {},
      admin_access:false,
      administrator:'',
      report_access: true,
      avg_source: null,
      avg_price_source:null,
      transient_source: null,
      permit_customer_source:null,
      anonymous_customer_source:null,
      first_year: 2018,
      years: [],
      // OpenIndicator: {
      //   render: (createElement) =>
      //     createElement("span", "", { class: { toggle: true } }),
      // },
      // Deselect: {
      //   render: (createElement) => createElement("span", "x"),
      // },
      windowWidth: 0,
      propertyListsheight: null,
      activeToSeeProperty: false,
      property_list: [],
      mapHeight: null,
      baseUrl: process.env.VUE_APP_BASE_URL,
      carouselSettings: {
        arrows: true,
        dots: false,
        variableWidth: true,
        infinite: false,
        centerMode: true,
        focusOnSelect: false,
        swipeToSlide: false,
        swipe: true,
        vertical: false,
        initialSlide: this.$moment().date() - 1,
      },
      month_list: [],
      currentMonth: null,
      currentYear: this.$moment().year(),
      currentMonthDate: this.$moment().month() + 1,
      today: this.$moment().date(),
      currentMonthName: this.$moment().format("MMMM"),
      currentDate: this.$moment().format("YYYY-MM-DD"),
      month_selector: this.$moment().month() + 1,
      activedate: null,
      activity_filter: 1,
      avg_session_loader: 0, // 0 => hidden, 1 => show loading icon, 2 => show reload button
      avg_session_price_loader: 0, // 0 => hidden, 1 => show loading icon, 2 => show reload button
      transient_loader: 0, // 0 => hidden, 1 => show loading icon, 2 => show reload button
      permit_customer_loader: 0, // 0 => hidden, 1 => show loading icon, 2 => show reload button
      anonymous_customer_loader: 0, // 0 => hidden, 1 => show loading icon, 2 => show reload button
      report_from: this.$moment().format("YYYY-MM-DD"),
      report_to: this.$moment().format("YYYY-MM-DD"),
      session_reports: {
        anonymous_customer: 0,
        anonymous_customer_inc: true,
        anonymous_customer_inc_value: "+" + 0,
        monthly_customer: 0,
        monthly_customer_inc: true,
        monthly_customer_inc_value: "+" + 0,
        avg_session_duration: 0,
        avg_session_duration_inc: true,
        avg_session_duration_inc_value: "+" + 0,
        avg_session_price: 0,
        avg_session_price_inc: true,
        avg_session_price_inc_value: "+" + 0,
        transient_customer: 0,
        transient_customer_inc: true,
        transient_customer_inc_value: "+" + 33.45,
      },
      activity_page: 1,
      activity_sorce: null,
      activity_loadMore: true,
      activity_infiniteId: +new Date(),
      activity_list: [],
      activity_loader: false,
      session_loader: false,
      report_filter: 1,
      report_type: "hour",
      //==== session , earning  =======//
      // active_session: 1,
      earning: 1,
      session_earning_loader: 0, // 0 => hidden, 1 => show loading icon, 2 => show reload button
      // session_chart_report_type: "hour",
      // session_chart_from: this.$moment().format("YYY-MM-DD"),
      // session_chart_to: this.$moment().format("YYYY-MM-DD"),
      session_chart: [],
      session_earning_chart_total: 0,
      session_earning_chart_percentage: "+0.00",
      session_earning_chart_inc: true,
      session_earning_source: null,
      //=========== Occupancy chart ===============//
      // active_occupancy: 1,
      occupancy_loader: 0, // 0 => hidden, 1 => show loading icon, 2 => show reload button
      // occupancy_chart_report_type: "hour",
      occupancy_chart: [],
      occupancy_total: 0.0,
      occupancy_inc: true,
      occupancy_inc_percentage: "+0.00",
      // occupancy_from: this.$moment().format("YYYY-MM-DD"),
      // occupancy_to: this.$moment().format("YYYY-MM-DD"),
      occupancy_source: null,
      search_city: "",
      role:'',
      space_ids:[],
      properties_loaded: false,
      occupancy_customer_type: 1,
      earning_customer_type: 1,
      permit_type_filter:1,
      earning_permit_type_filter:1,
    };
  },
  created() {
    this.helperTexts = helperTexts;
    this.getDaysArray(this.currentYear, this.currentMonthDate);
    this.updateActivity();
    this.onResize();
    if(localStorage.getItem('admin_access') && localStorage.getItem("admin_access") == 'true') {
      this.admin_access = true;
    }
    if(localStorage.getItem('role') && localStorage.getItem("role") == 'operator'){
      this.role  = 'operator';
      let property_access =localStorage.getItem('commercial_access_list');
      property_access =JSON.parse(property_access)
      let property_access_list =property_access.property_access_list;
      this.space_ids  = property_access_list;
      // console.log(this.space_ids);
    }

    window.EventBus.$on("access_update",()=>{
      this.reportAccess();
    });
    
    if(this.properties_loaded === true)
    {
      window.EventBus.$on("report_switcher", (data) => {
        this.changeFilter(data);
      });
    }

    let datas = this.first_year;
    for (datas; datas <= this.currentYear; datas++) {
      this.years.push({
        name: datas,
        value: datas,
      });
    }
  },
  mounted() {
    this.getMonthList();
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    this.reportAccess();
  },
  beforeDestroy() {
    // window.EventBus.$emit("week_switcher");
    window.removeEventListener("resize", this.onResize);
  },

  computed: {
    filteredList() {
      return this.sessionsLists.filter((session) => {
        return session.carDetails.license
          .toLowerCase()
          .includes(this.sessionSearch.toLowerCase());
      });
    },
  },
  methods: {
    getSessionAndEarnings(type, cust_type, permit_type = 1)
    {
      this.earning_permit_type_filter = permit_type;
      this.earning = type;
      this.earning_customer_type = cust_type;
      if (this.earning == 1) {
        this.getSessionChartData(cust_type);
      } else {
        this.getEarningChartData(cust_type);
      }
    },
    reportAccess() {
      let access = localStorage.getItem("commercial_access_list");
      access = JSON.parse(access);
      if(access && Object.keys(access).length > 0) {
        if(Object.keys(access).includes('report_access')) {
          this.report_access = access.report_access;
        }
      }

      if(this.report_access) {
        // this.getAvgSessionReport();
        // this.getAvgSessionPrice();
        this.getTransientReport();   
        this.getPermitCustomer();
        this.getAnonymousCustomer();
        this.getSessionChartData();
        this.getOccupancyChartData(this.occupancy_customer_type);
      }
    },
    getMonthList() {
      this.month_list = [];
      //alert(this.currentMonthDate);
      for (let i = 1; i <= this.currentMonthDate; i++) {
        var d = "";
        if (i < 10) {
          d = this.currentYear + "-0" + i + "-01";
        } else {
          d = this.currentYear + "-" + i + "-01";
        }
        this.month_list.push({
          name: this.$moment(d).format("MMMM"),
          value: this.$moment(d).month() + 1,
        });
      }
      if (this.currentYear != this.$moment().year()) {
        // it reset to jan for all years except the current year
        this.currentMonthDate = 1; // for current year it display the current date with the current month selected by default when change evnt occur
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth < 991) {
        this.activeToSeeProperty = true;
      }
    },
    mapHeightmethod() {
      if (this.windowWidth > 991) {
        this.activeToSeeProperty = false;
        this.propertyListsheight = 112;
        this.mapHeight = 670;
      }
    },
    showPropertyLists() {
      if (this.windowWidth > 991) {
        this.activeToSeeProperty = true;
        this.propertyListsheight = 600;
        this.mapHeight = 180;
      }
    },
    getDaysByMonth(month) {
      const daysInMonth = this.$moment(month).daysInMonth();
      return Array.from({ length: daysInMonth }, (v, k) => k + 1);
    },
    focusDate(i, e) {
      if (i > this.today - 1) {
        e.stopPropagation();
      } else {
        this.activedate = i;
        // let date =
        //   this.currentMonthDate < 10
        //     ? this.currentYear + "-0" + this.currentMonthDate + "-" + (i + 1)
        //     : this.currentYear + "-" + this.currentMonthDate + "-" + (i + 1);
        this.activity_page = 1;
        this.activity_list = [];
        this.activity_infiniteId += 1;
      }
    },
    changeActivityYear() {
      if (this.currentYear == this.$moment().year()) {
        this.currentMonthDate = this.$moment().month() + 1;
      } else {
        this.currentMonthDate = 12;
      }
      this.getMonthList();
      this.changeActivityMonth();
    },
    changeActivityMonth() {
      console.log('testing');
      if (
        this.currentYear == this.$moment().year() &&
        this.currentMonthDate == this.$moment().month() + 1
      ) {
        this.today = this.$moment().date();
      } else {
        let date =
          this.currentMonthDate < 10
            ? this.currentYear + "-0" + this.currentMonthDate + "-01"
            : this.currentYear + "-" + this.currentMonthDate + "-01";
        this.today = this.$moment(date).endOf("month").date();
      }
      //alert(this.currentYear+"month>>"+this.currentMonthDate);
      this.getDaysArray(this.currentYear, this.currentMonthDate);
      //alert("TTTTT"+this.today);
      if (
        this.currentYear == this.$moment().year() &&
        this.currentMonthDate == this.$moment().month() + 1
      ) {
        this.focusDate(this.today - 1, "");
      } else {
        this.focusDate(0, "");
      }
    },
    getDaysArray(year, month) {
      const monthIndex = month - 1;
      const names = Object.freeze([
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat",
      ]);
      const date = new Date(year, monthIndex, 1);
      const result = [];
      while (date.getMonth() == monthIndex) {
        // result.push(`${date.getDate()}-${names[date.getDay()]}`);
        result.push({
          date: date.getDate(),
          day: names[date.getDay()],
          full_date: this.$moment(date).format("YYYY-MM-DD"),
        });
        date.setDate(date.getDate() + 1);
      }
      this.currentMonth = result;
    },
    changeFilter(filter) {
      this.session_report = [];
      switch (filter) {
        case 1: // get today session / earning report
          // this.active_session = filter;
          this.report_filter = filter;
          this.report_type = "hour";
          this.report_from = this.$moment().format("YYYY-MM-DD");
          this.report_to = this.$moment().format("YYYY-MM-DD");
          // this.session_chart_report_type = "hour";
          this.getOccupancyChartData(this.occupancy_customer_type);
        //   this.getAvgSessionReport();
        //   this.getAvgSessionPrice();
          this.getTransientReport();
          this.getPermitCustomer();
          this.getAnonymousCustomer();
          if (this.earning == 1) {
            this.getSessionChartData(this.earning_customer_type);
          } else {
            this.getEarningChartData(this.earning_customer_type);
          }
          // this.occupancy_chart_report_type = "hour";

          break;
        case 2: //get weekly session / earning report
          // this.active_session = filter;
          this.report_filter = filter;
          this.report_type = "week";
          this.report_from = this.$moment()
            .add(-7, "days")
            .format("YYYY-MM-DD");
          this.report_to = this.$moment().add(-1, "days").format("YYYY-MM-DD");
          // this.session_chart_report_type = "week";
          this.getOccupancyChartData(this.occupancy_customer_type);
        //   this.getAvgSessionReport();
          this.getTransientReport();
          this.getPermitCustomer();
          this.getAnonymousCustomer();
          if (this.earning == 1) {
            this.getSessionChartData(this.earning_customer_type);
          } else {
            this.getEarningChartData(this.earning_customer_type);
          }
          // this.occupancy_chart_report_type = "week";
          // this.getOccupancyChartData();
          break;
        case 3: // get monthly session / earning report
          // this.active_session = filter;
          this.report_filter = filter;
          this.report_type = "month";
          this.report_from = this.$moment()
            .startOf("year")
            .format("YYYY-MM-DD");
          this.report_to = this.$moment().endOf("month").format("YYYY-MM-DD");
          this.getOccupancyChartData(this.occupancy_customer_type);
        //   this.getAvgSessionReport();
        //   this.getAvgSessionPrice();
          this.getTransientReport();
          this.getPermitCustomer();
          this.getAnonymousCustomer();
          // this.session_chart_report_type = "month";
          if (this.earning == 1) {
            this.getSessionChartData(this.earning_customer_type);
          } else {
            this.getEarningChartData(this.earning_customer_type);
          }
          // this.occupancy_chart_report_type = "month";
          // this.getOccupancyChartData();
          break;
        case 4: // get yearly session / earning report
          // this.active_session = filter;
          this.report_filter = filter;
          // this.session_chart_report_type = "year";
          this.report_type = "year";
          this.report_from = "2018-01-01";
          this.report_to = this.$moment().endOf("month").format("YYYY-MM-DD");
          this.getOccupancyChartData(this.occupancy_customer_type);
        //   this.getAvgSessionReport();
        //   this.getAvgSessionPrice();
          this.getTransientReport();
          this.getPermitCustomer();
          this.getAnonymousCustomer();
          if (this.earning == 1) {
            this.getSessionChartData(this.earning_customer_type);
          } else {
            this.getEarningChartData(this.earning_customer_type);
          }
          // this.occupancy_chart_report_type = "year";
          // this.getOccupancyChartData();
          break;
        case 5: // toggle from earning to sessions
          this.earning = 1;
          this.getSessionChartData(this.earning_customer_type);
          break;
        case 6: // toggle from sessions to earning
          this.earning = 2;
          this.getEarningChartData(this.earning_customer_type);
          break;
        // case 7: // get hourly occupancy report
        //   this.active_occupancy = 1;
        //   this.occupancy_chart_report_type = "hour";
        //   this.getOccupancyChartData();
        //   break;
        // case 8: // get weekly occupancy report
        //   this.active_occupancy = 2;
        //   this.occupancy_chart_report_type = "week";
        //   this.getOccupancyChartData();
        //   break;
        // case 9: // get monthly occupancy report
        //   this.active_occupancy = 3;
        //   this.occupancy_chart_report_type = "month";
        //   this.getOccupancyChartData();
        //   break;
        // case 10: // get yearly occupancy report
        //   this.active_occupancy = 4;
        //   this.occupancy_chart_report_type = "year";
        //   this.getOccupancyChartData();
        //   break;
        // case 11:
        //   this.activity_filter = 2;
        //   break;
        // case 12:
        //   this.activity_filter = 3;
        //   break;
        // case 13:
        //   this.activity_filter = 4;
        //   break;
        default:
          window.location.refresh();
          break;
      }
    },
    getAvgSessionReport() {
      // Avg session duration calculation
      if (this.avg_source) {
        this.avg_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.avg_source = CancelToken.source();

      this.avg_session_loader = 1;
      this.axios
        .post(
          window.hostname + "/api/auth/reports/avg-duration",
          {
            device_type: 1,
            commercial: 1,
            // to: this.$moment().add(-1, "days").format("YYYY-MM-DD"),
            // from: this.$moment().add(-7, "days").format("YYYY-MM-DD"),
            from: this.report_from,
            to: this.report_to,
            report_type: this.report_type,
            time_zone: this.$moment.tz.guess(),
          },
          {
            cancelToken: this.avg_source.token,
          }
        )
        .then((res) => {
          this.avg_session_loader = 0;

          if(!res.data.status) {
            return;
          }
          let response = service.getCalculateData(res.data.data.avg_session_duration_seconds,res.data.data.avg_session_duration_seconds_past);
          // console.log(res.data.data);
          // console.log(response);
          this.session_reports.avg_session_duration=res.data.data.avg_session_duration;
          this.session_reports.avg_session_duration_inc_value = response.data_inc;
          this.session_reports.avg_session_duration_inc = response.data_inc_status;
          // console.log(this.session_reports.avg_session_price_inc); 
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            // console.log("Request canceled", err);
            this.avg_session_loader = 1;
          } else {
            this.avg_session_loader = 2;
            // console.log(err);
          }
        });
    },
    // Session price calculation
    getAvgSessionPrice(){
      if (this.avg_price_source) {
        this.avg_price_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.avg_price_source = CancelToken.source();
      this.avg_session_price_loader = 1;
      this.axios
        .post(
          window.hostname + "/api/auth/reports/avg-price",
          {
            device_type: 1,
            commercial: 1,
            // to: this.$moment().add(-1, "days").format("YYYY-MM-DD"),
            // from: this.$moment().add(-7, "days").format("YYYY-MM-DD"),
            from: this.report_from,
            to: this.report_to,
            report_type: this.report_type,
            time_zone: this.$moment.tz.guess(),
          },
          {
            cancelToken: this.avg_price_source.token,
          }
        ).then((res)=>{
          this.avg_session_price_loader = 0;
            if(!res.data.status) {
              return;
            }
          let response=service.getCalculateData(res.data.data.avg_session_price,res.data.data.avg_session_price_past);
          this.session_reports.avg_session_price =res.data.data.avg_session_price.toFixed(2);
          this.session_reports.avg_session_price_inc_value =response.data_inc;
          this.session_reports.avg_session_price_inc = response.data_inc_status;
        })
        .catch(err=> {
          if(this.axios.isCancel(err)) {
            this.avg_session_price_loader = 1;
          }
          else {
            this.avg_session_price_loader = 2;
          }
        });
    },
    getTransientReport() {
      if (this.transient_source) {
        this.transient_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.transient_source = CancelToken.source();

      this.transient_loader = 1;
      this.axios
        .post(
          window.hostname + "/api/auth/reports/transient-customers",
          {
            device_type: 1,
            commercial: 1,
            // to: this.$moment().add(-1, "days").format("YYYY-MM-DD"),
            // from: this.$moment().add(-7, "days").format("YYYY-MM-DD"),
            from: this.report_from,
            to: this.report_to,
            report_type: this.report_type,
            time_zone: this.$moment.tz.guess(),
          },
          {
            cancelToken: this.transient_source.token,
          }
        )
        .then((res) => {
          this.transient_loader = 0;
            if(!res.data.status){
              return;
            }
          let response =service.getCalculateData(res.data.data.current_transient_customer_count , res.data.data.past_transient_customer_count);
          this.session_reports.transient_customer = res.data.data.current_transient_customer_count;
          this.session_reports.transient_customer_inc_value =response.data_inc;
          this.session_reports.transient_customer_inc =response.data_inc_status;
          // console.log(res);
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            // console.log("Request canceled", err);
            this.transient_loader = 1;
          } else {
            // console.log(err);
            this.transient_loader = 2;
          }
        });
    },
    getPermitCustomer(){
      if (this.permit_customer_source) {
        this.permit_customer_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.permit_customer_source = CancelToken.source();

      this.permit_customer_loader =0;
      this.axios
        .post(
          window.hostname + "/api/auth/reports/permit-customers",
          {
            device_type: 1,
            commercial: 1,
            // to: this.$moment().add(-1, "days").format("YYYY-MM-DD"),
            // from: this.$moment().add(-7, "days").format("YYYY-MM-DD"),
            from: this.report_from,
            to: this.report_to,
            report_type: this.report_type,
            time_zone: this.$moment.tz.guess(),
          },
          {
            cancelToken: this.permit_customer_source.token,
          }
        ).then((res)=>{
          this.permit_customer_loader = 0;
            if(!res.data.status){
              return;
            }
            let response =service.getCalculateData(res.data.data.current_permit_customer_count, res.data.data.past_permit_customer_count);
            this.session_reports.monthly_customer =res.data.data.current_permit_customer_count;
            this.session_reports.monthly_customer_inc_value=response.data_inc;
            this.session_reports.monthly_customer_inc =response.data_inc_status;
            // console.log(response);
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            // console.log("Request canceled", err);
            this.permit_customer_loader = 1;
          } else {
            // console.log(err);
            this.permit_customer_loader = 2;
          }
        });
    },
    getAnonymousCustomer(){
      if (this.anonymous_customer_source) {
        this.anonymous_customer_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.anonymous_customer_source = CancelToken.source();
      this.anonymous_customer_loader=1;
      this.axios
        .post(
          window.hostname + "/api/auth/reports/anonymous-customers",
          {
            device_type: 1,
            commercial: 1,
            // to: this.$moment().add(-1, "days").format("YYYY-MM-DD"),
            // from: this.$moment().add(-7, "days").format("YYYY-MM-DD"),
            from: this.report_from,
            to: this.report_to,
            report_type: this.report_type,
            time_zone: this.$moment.tz.guess(),
          },
          {
            cancelToken: this.anonymous_customer_source.token,
          }
        ).then((res)=>{
          this.anonymous_customer_loader=0;

          if(!res.data.status){
            return;
          }
          let response =service.getCalculateData(res.data.data.current_anonymous_customer_count,res.data.data.past_anonymous_customer_count);
          this.session_reports.anonymous_customer = res.data.data.current_anonymous_customer_count;
          this.session_reports.anonymous_customer_inc_value =response.data_inc;
          this.session_reports.anonymous_customer_inc =response.data_inc_status;

          // console.log(response);
        })      
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            // console.log("Request canceled", err);
            this.anonymous_customer_loader = 1;
          } else {
            // console.log(err);
            this.anonymous_customer_loader = 2;
          }
        });
    },
    getActivities($state) {
      let day = null;

      if (this.activedate == null) {
        day = this.today;
      } else {
        day = this.activedate + 1;
      }
      let currentMonthDate = this.currentMonthDate;
      if (this.currentMonthDate < 10) {
        currentMonthDate = "0" + currentMonthDate;
      }
      if (day < 10) {
        day = "0" + day;
      }
      let date = this.currentYear + "-" + currentMonthDate + "-" + day;

      if (this.activity_sorce) {
        this.activity_sorce.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.activity_sorce = CancelToken.source();
      if(this.admin_access){
        this.administrator=1;
      }
      this.axios
        .post(
          window.hostname + "/api/auth/activity-list",
          {
            device_type: 1,
            page: this.activity_page,
            limit: 10,
            date: date,
            time_zone: this.$moment.tz.guess(),
            administrator:this.administrator,
            space_ids :this.space_ids
          },
          {
            cancelToken: this.activity_sorce.token,
          }
        )
        .then((res) => {
          if (res.data.status) {
            if (res.data.data.activity_list) {
              let activity = res.data.data.activity_list;
              activity.map((data) => {
                this.activity_list.push(data);
              });
              this.activity_loadMore =
                res.data.data.pagination.load_more == 1 ? true : false;
              this.activity_page = res.data.data.pagination.page;
              $state.loaded();
              if (!this.activity_loadMore) {
                $state.complete();
              }
            } else {
              this.activity_list = [];
              this.activity_page = 1;
              this.activity_loadMore = false;
              $state.complete();
            }
          } else {
            this.activity_list = [];
            this.activity_page = 1;
            this.activity_loadMore = false;
            $state.complete();
          }
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            console.log("Request canceled", err.message);
          } else {
            $state.error();
          }
        });
    },
    updateActivity() {
      this.axios
        .post(window.hostname + "api/auth/activity-seen", {})
        .then((res) => {
          // console.log(res);
          // this.unseen_activity = res.data.data.count;
        })
        .catch((error) => {
          console.log(error);
          // localStorage.removeItem("commercial_token_new");
          // this.$router.push({ path: "/login" });
        });
    },
    getSessionChartData(cust_type) {
      this.session_chart = [];
      this.session_earning_loader = 1;

      if (this.session_earning_source) {
        this.session_earning_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.session_earning_source = CancelToken.source();

      this.axios
        .post(
          // window.hostname + "api/auth/session-report",
          window.hostname + "api/auth/reports/sessions",
          {
            time_zone: this.$moment.tz.guess(new Date()),
            from: this.report_from,
            to: this.report_to,
            commercial: 1,
            report_type: this.report_type,
            customer_type: cust_type,
            permit_type: this.earning_permit_type_filter
          },
          {
            cancelToken: this.session_earning_source.token,
          }
        )
        .then((res) => {
          this.session_earning_loader = 0;
          if (res.data.status) {
            this.session_chart = res.data.data.report_data;
            this.session_earning_chart_total = parseInt(res.data.data.total);
            if (this.report_type == "hour" || this.report_type == "week") {
              if (
                parseFloat(res.data.data.total) >=
                parseFloat(res.data.data.total_prev)
              ) {
                this.session_earning_chart_inc = true;
                if (
                  parseFloat(res.data.data.total) ==
                  parseFloat(res.data.data.total_prev)
                ) {
                  this.session_earning_chart_percentage = "+0.00";
                } else if (
                  parseFloat(res.data.data.total) != 0 &&
                  parseFloat(res.data.data.total_prev) == 0
                ) {
                  this.session_earning_chart_percentage = "+100.00";
                } else {
                  this.session_earning_chart_percentage = (
                    ((parseFloat(res.data.data.total) -
                      parseFloat(res.data.data.total_prev)) /
                      parseFloat(res.data.data.total_prev)) *
                    100
                  ).toFixed(2);
                  this.session_earning_chart_percentage =
                    this.session_earning_chart_percentage > 100
                      ? "+100.00"
                      : "+" + this.session_earning_chart_percentage;
                }
              } else {
                this.session_earning_chart_inc = false;
                if (
                  parseFloat(res.data.data.total) == 0 &&
                  parseFloat(res.data.data.total_prev) != 0
                ) {
                  this.session_earning_chart_percentage = "-100.00";
                } else {
                  this.session_earning_chart_percentage = (
                    ((parseFloat(res.data.data.total_prev) -
                      parseFloat(res.data.data.total)) /
                      parseFloat(res.data.data.total_prev)) *
                    100
                  ).toFixed(2);
                  this.session_earning_chart_percentage =
                    this.session_earning_chart_percentage > 100
                      ? "-100.00"
                      : "-" + this.session_earning_chart_percentage;
                }
              }
            } else {
              let length = this.session_chart.length - 1;
              let last_value = parseInt(this.session_chart[length].y);
              let prev_value = parseInt(res.data.data.total_prev);
              if (last_value >= prev_value) {
                this.session_earning_chart_inc = true;
                if (prev_value == 0 && last_value != 0) {
                  this.session_earning_chart_percentage = "+100.00";
                } else if (prev_value == last_value) {
                  this.session_earning_chart_percentage = "+0.00";
                } else {
                  this.session_earning_chart_percentage = (
                    ((last_value - prev_value) / prev_value) *
                    100
                  ).toFixed(2);
                  this.session_earning_chart_percentage =
                    this.session_earning_chart_percentage > 100
                      ? "+100.00"
                      : "+" + this.session_earning_chart_percentage;
                }
              } else {
                this.session_earning_chart_inc = false;
                if (prev_value != 0 && last_value == 0) {
                  this.session_earning_chart_percentage = "-100.00";
                } else {
                  this.session_earning_chart_percentage = (
                    ((prev_value - last_value) / prev_value) *
                    100
                  ).toFixed(2);
                  this.session_earning_chart_percentage =
                    this.session_earning_chart_percentage > 100
                      ? "-100.00"
                      : "-" + this.session_earning_chart_percentage;
                }
              }
            }
          }
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            // console.log("Request canceled", err);
            this.session_earning_loader = 1;
          } else {
            this.session_earning_loader = 2;

            if (err.response && err.response.status == 401) {
              return;
            }
            // this.session_earning_loader = 2;
            // this.$toasted.show("Something went wrong. Please try again!", {
            //   icon: "times-circle",
            //   className: "error-class",
            // });
          }
        });
    },
    async getEarningChartData(cust_type) {
      this.session_chart = [];
      this.session_earning_loader = 1;
      if (this.session_earning_source) {
        this.session_earning_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.session_earning_source = CancelToken.source();

      await this.axios
        .post(
          window.hostname + "api/auth/reports/earnings",
          {
            report_type: this.report_type,
            from: this.report_from,
            to: this.report_to,
            commercial: 1,
            time_zone: this.$moment.tz.guess(new Date()),
            customer_type: cust_type,
          },
          {
            cancelToken: this.session_earning_source.token,
          }
        )
        .then((res) => {
          this.session_earning_loader = 0;
          if (res.data.status) {
            this.session_chart = res.data.data.report_data;
            this.session_earning_chart_total = parseFloat(
              res.data.data.total
            ).toFixed(2);
            if (this.report_type == "hour" || this.report_type == "week") {
              if (
                parseFloat(res.data.data.total) >=
                parseFloat(res.data.data.total_prev)
              ) {
                this.session_earning_chart_inc = true;
                if (
                  parseFloat(res.data.data.total) ==
                  parseFloat(res.data.data.total_prev)
                ) {
                  this.session_earning_chart_percentage = "+0.00";
                } else if (
                  parseFloat(res.data.data.total) != 0 &&
                  parseFloat(res.data.data.total_prev) == 0
                ) {
                  this.session_earning_chart_percentage = "+100.00";
                } else {
                  this.session_earning_chart_percentage = (
                    ((parseFloat(res.data.data.total) -
                      parseFloat(res.data.data.total_prev)) /
                      parseFloat(res.data.data.total_prev)) *
                    100
                  ).toFixed(2);
                  this.session_earning_chart_percentage =
                    this.session_earning_chart_percentage > 100
                      ? "+100.00"
                      : "+" + this.session_earning_chart_percentage;
                }
              } else {
                this.session_earning_chart_inc = false;
                if (
                  parseFloat(res.data.data.total) == 0 &&
                  parseFloat(res.data.data.total_prev) != 0
                ) {
                  this.session_earning_chart_percentage = "-100.00";
                } else {
                  this.session_earning_chart_percentage = (
                    ((parseFloat(res.data.data.total_prev) -
                      parseFloat(res.data.data.total)) /
                      parseFloat(res.data.data.total_prev)) *
                    100
                  ).toFixed(2);
                  this.session_earning_chart_percentage =
                    this.session_earning_chart_percentage > 100
                      ? "-100.00"
                      : "-" + this.session_earning_chart_percentage;
                }
              }
            } else {
              let length = this.session_chart.length - 1;
              let last_value = parseFloat(this.session_chart[length].y);
              let prev_value = parseFloat(res.data.data.total_prev);
              if (last_value >= prev_value) {
                this.session_earning_chart_inc = true;
                if (prev_value == 0 && last_value != 0) {
                  this.session_earning_chart_percentage = "+100.00";
                } else if (prev_value == last_value) {
                  this.session_earning_chart_percentage = "+0.00";
                } else {
                  this.session_earning_chart_percentage = (
                    ((last_value - prev_value) / prev_value) *
                    100
                  ).toFixed(2);
                  this.session_earning_chart_percentage =
                    this.session_earning_chart_percentage > 100
                      ? "+100.00"
                      : "+" + this.session_earning_chart_percentage;
                }
              } else {
                this.session_earning_chart_inc = false;
                if (prev_value != 0 && last_value == 0) {
                  this.session_earning_chart_percentage = "-100.00";
                } else {
                  this.session_earning_chart_percentage = (
                    ((prev_value - last_value) / prev_value) *
                    100
                  ).toFixed(2);
                  this.session_earning_chart_percentage =
                    this.session_earning_chart_percentage > 100
                      ? "-100.00"
                      : "-" + this.session_earning_chart_percentage;
                }
              }
            }
          }
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            // console.log("Request canceled", err.message);
            this.session_earning_loader = 1;
          } else {
            this.session_earning_loader = 2;
            if (err.response.status == 401) {
              return;
            }

            // this.$toasted.show("Something went wrong. Please try again!", {
            //   icon: "times-circle",
            //   className: "error-class",
            // });
          }
        });
    },
    getOccupancyChartData(cust_type, permit_type = 1) {
      this.permit_type_filter = permit_type;
      this.occupancy_loader = 1;
      this.occupancy_chart = [];
      this.occupancy_customer_type = cust_type;
      
      if (this.occupancy_source) {
        this.occupancy_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.occupancy_source = CancelToken.source();

      this.axios
        .post(
          window.hostname + "api/auth/reports/occupancy",
          {
            report_type: this.report_type,
            from: this.report_from,
            to: this.report_to,
            commercial: 1,
            time_zone: this.$moment.tz.guess(new Date()),
            customer_type: cust_type,
            permit_type: this.permit_type_filter,
          },
          {
            cancelToken: this.occupancy_source.token,
          }
        )
        .then((res) => {
          this.occupancy_loader = 0;
          if (res.data.status) {
            this.occupancy_chart = res.data.data.report_data;
            this.occupancy_total = res.data.data.total.toFixed(0);
            if (
              parseFloat(res.data.data.total) >
              parseFloat(res.data.data.total_prev)
            ) {
              this.occupancy_inc = true;
              let diff_data =
                parseFloat(res.data.data.total) -
                parseFloat(res.data.data.total_prev);
              let perc = (diff_data / parseFloat(res.data.data.total)) * 100;
              perc = perc.toFixed(2);
              perc = perc > 100 ? 100 : perc;
              this.occupancy_inc_percentage = "+" + perc;
            } else if (
              parseFloat(res.data.data.total) <
              parseFloat(res.data.data.total_prev)
            ) {
              this.occupancy_inc = false;
              let diff_data =
                parseFloat(res.data.data.total_prev) -
                parseFloat(res.data.data.total);
              let perc =
                (diff_data / parseFloat(res.data.data.total_prev)) * 100;
              perc = perc.toFixed(2);
              perc = perc > 100 ? 100 : perc;
              this.occupancy_inc_percentage = "-" + perc;
            } else {
              this.occupancy_inc = true;
              this.occupancy_inc_percentage = "+0.00";
            }
          }
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            this.occupancy_loader = 1;
          } else {
            // console.log(err);
            this.occupancy_loader = 2;
            if (err.response && err.response.status == 401) {
              return;
            }
            // this.$toasted.show("Something went wrong. Please try again!", {
            //   icon: "times-circle",
            //   className: "error-class",
            // });
          }
        });
    },
    getPropertyList(event) {
      this.property_list = event;
      this.properties_loaded = true;
      // this.axios
      //   .post(window.hostname + "api/auth/all-space", {
      //     limit: 100,
      //     device_type: 1,
      //     space_type: 1,
      //     search_city: this.search_city,
      //     status: 0,
      //     page: 1,
      //     time_zone: this.$moment.tz.guess(new Date())
      //   })
      //   .then(res => {
      //     if (res.data.status) {
      //       this.property_list = res.data.data.all_space;
      //     } else {
      //       this.property_list = [];
      //     }
      //   })
      //   .catch(err => {
      //     console.log(err);
      //     this.property_list = [];
      //   });
    },
    redirectPropertyDetails(property_id) {
      if (this.activeToSeeProperty === true) {
        this.$router.push({
          name: "Property",
          query: { p: property_id },
        });
      }
      // this.$router.push({ name: "Property", query: { p: property_id } });
    },
    circle(occupancy) {
      return (occupancy / 100) * 100 * Math.PI + ",9999";
    },
    getCityName(event) {
      this.search_city = event;
      this.getPropertyList();
    },
    openModal(activity) {
      if (activity.target == "bookings") {
        this.axios
          .post(window.hostname + "/api/auth/booking", {
            booking_id: activity.target_id,
            mode: "show-booking",
            time_zone: this.$moment.tz.guess(new Date()),
            booking_for: "owner",
            administrator:this.administrator
          })
          .then((res) => {
            if (res.data.status) {
              this.$modal.show("session-details", {
                data: res.data.data.booking_details,
                session_type:
                  res.data.data.booking_details.booking_end_date != "" ? 2 : 1,
              });
            } else {
              return;
            }
          })
          .catch((err) => {
            return;
          });
      }
    },
    refreshActivity() {
      let m = parseInt(this.$moment().month()) + 1;
      // let date = this.$moment().year() + "-" + m + "-" + this.$moment().date();
      this.activedate = null;
      this.activity_list = [];
      this.activity_page = 1;
      // this.getActivity(date);
      this.activity_infiniteId += 1;
    },
  },
};
</script>
<style>
.slick-slider {
  padding-left: 5px;
  padding-right: 5px;
}
.slick-list {
  padding: 0 35px !important;
}
.vue-map-container .vue-map {
  border-radius: 10px;
}
.modal-backdrop.show {
  opacity: 0.8;
}
.style-chooser {
  width: 200px;
}
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  /* background: #dfe5fb; */
  /* border: none; */
  font-size: 10px;
  font-weight: 600;
  color: #f5a621;
  font-family: "Open Sans", sans-serif;
}
.style-chooser .vs__selected {
  color: #f5a621;
}
.style-chooser .vs__dropdown-menu {
  background: #191919;
  color: #f5a621;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #f5a621;
  /* width: 7px; */
  font-size: 14px;
  color: #f5a621;
}
.style-chooser .vs__dropdown-option {
  color: #f5a621;
}
.style-chooser .vs__dropdown-option--highlight {
  background: #f5a621;
  color: #fff;
}
.monthly-filter-select {
  width: 120px !important;
}
</style>
